import { render, staticRenderFns } from "./Group_account.vue?vue&type=template&id=6ff4d33e&"
import script from "./Group_account.vue?vue&type=script&lang=js&"
export * from "./Group_account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports